





// import { MdLocationPin, MdStar } from "react-icons/md";
// import { Link } from "react-router-dom";
// import { FaShareAlt } from "react-icons/fa"; // Import share icon from react-icons

// function JobPostJobPage({
//   position,
//   location,
//   companyName,
//   salary,
//   jobType,
//   experience,
//   duration,
//   status,
//   jobId,
//   contactMail,
//   localGovernment,
//   city,
  
// }) {
//   const handleMailCompany = () => {
//     window.location.href = `mailto:${contactMail}?subject=${position}`;
//   };

//   const handleShare = () => {
//     if (navigator.share) {
//       navigator.share({
//         title: `${position} at ${companyName}`,
//         text: `Check out this job opportunity: ${position} in ${location} (LGA: ${localGovernment}, City: ${city}). Apply now!`,
//         url: window.location.origin + `/job/${jobId}`,
//       }).catch((error) => console.error("Error sharing:", error));
//     } else {
//       navigator.clipboard.writeText(window.location.origin + `/job/${jobId}`);
//       alert("Link copied to clipboard!");
//     }
//   };

//   return (
//     <div className="sm:p-5 p-4 bg-white shadow-md text-sm border border-gray-200 rounded-lg mb-6 relative overflow-hidden transition-transform transform hover:scale-105">
//       <div className="bg-orange-500 absolute -top-[14px] -left-[65px] w-[200px] h-[100px] rotate-[314.5deg]"></div>
//       <div className="relative z-10">
//         <div className="z-10 absolute -top-2 right-2 bg-yellow-400 p-2 rounded-full">
//           <MdStar className="relative text-white w-5 h-5 z-10" />
//         </div>
//         <div className="mb-4">
//           <h1 className="text-2xl relative z-30 font-bold text-gray-800 capitalize">
//             {position}
//           </h1>
//           <h2 className="text-xl capitalize text-gray-600">{companyName}</h2>
//         </div>
//         <div className="flex items-center justify-between mb-4">
//           <div className="flex items-center text-gray-600">
//             <MdLocationPin className="text-orange-500 mr-2" />
//             <span>{location} (LGA: {localGovernment}, City: {city})</span>
//           </div>
//           <div className="text-gray-600">
//             <span>Salary: {salary}</span>
        

//           </div>
//         </div>
//         <div className="text-gray-600 mb-4 flex items-center justify-between flex-col sm:flex-row">
//           <span className="font-semibold">Job Type: {jobType}</span>
//           {contactMail ? (
//             <button onClick={handleMailCompany}>
//               Contact:{" "}
//               <span className="hover:text-orange-400 underline">
//                 {contactMail}
//               </span>
//             </button>
//           ) : null}
//         </div>
//         <div className="flex items-center justify-between border-t pt-4 text-gray-600">
//           <div>
//             <p>Experience Level: {experience}</p>
//             <p>Posted: {new Date(duration).toLocaleDateString()}</p>
//           </div>
//           <div className="flex items-center gap-2">
//             <Link to={`/job/${jobId}`} className="text-orange-500 font-semibold hover:underline">
//               {status}
//             </Link>
//             <button
//               onClick={handleShare}
//               className="text-blue-500 hover:text-blue-700 transition"
//               title="Share this job"
//             >
//               <FaShareAlt size={18} /> {/* Replace text with share icon */}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default JobPostJobPage;





import { MdLocationPin, MdStar } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaShareAlt } from "react-icons/fa"; // Import share icon from react-icons

function JobPostJobPage({
  position,
  location,
  companyName,
  salary,
  jobType,
  experience,
  duration,
  status,
  jobId,
  contactMail,
  localGovernment,
  city,
}) {
  const handleMailCompany = () => {
    window.location.href = `mailto:${contactMail}?subject=${position}`;
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `${position} at ${companyName}`,
        text: `Check out this job opportunity: ${position} in ${location} (LGA: ${localGovernment}, City: ${city}). Apply now!`,
        url: window.location.origin + `/job/${jobId}`,
      }).catch((error) => console.error("Error sharing:", error));
    } else {
      navigator.clipboard.writeText(window.location.origin + `/job/${jobId}`);
      alert("Link copied to clipboard!");
    }
  };

  return (
    <div className="sm:p-5 p-4 bg-white shadow-md text-sm border border-gray-200 rounded-lg mb-6 relative overflow-hidden transition-transform transform hover:scale-105">
      <div className="bg-green-500 absolute -top-[14px] -left-[65px] w-[200px] h-[100px] rotate-[314.5deg]"></div>
      <div className="relative z-10">
        <div className="z-10 absolute -top-2 right-2 bg-yellow-400 p-2 rounded-full">
          <MdStar className="relative text-white w-5 h-5 z-10" />
        </div>
        <div className="mb-4">
          <h1 className="text-2xl relative z-30 font-bold text-gray-800 capitalize">
            {position}
          </h1>
          <h2 className="text-xl capitalize text-gray-600">{companyName}</h2>
        </div>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center text-gray-600">
            <MdLocationPin className="text-green-500 mr-2" />
            <span>{location} (LGA: {localGovernment}, City: {city})</span>
          </div>
          <div className="text-gray-600">
            <span>Salary: {salary}</span>
          </div>
        </div>
        <div className="text-gray-600 mb-4 flex items-center justify-between flex-col sm:flex-row">
          <span className="font-semibold">Job Type: {jobType}</span>
          {contactMail ? (
            <button onClick={handleMailCompany}>
              Contact:{" "}
              <span className="hover:text-green-400 underline">
                {contactMail}
              </span>
            </button>
          ) : null}
        </div>
        <div className="flex items-center justify-between border-t pt-4 text-gray-600">
          <div>
            <p>Experience Level: {experience}</p>
            <p>Posted: {new Date(duration).toLocaleDateString()}</p>
          </div>
          <div className="flex items-center gap-2">
            <Link to={`/job/${jobId}`} className="text-green-500 font-semibold hover:underline">
              {status}
            </Link>
            <button
              onClick={handleShare}
              className="text-blue-500 hover:text-blue-700 transition"
              title="Share this job"
            >
              <FaShareAlt size={18} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default JobPostJobPage;